import { render, staticRenderFns } from "./IUBHComplete.vue?vue&type=template&id=d9bd2dd2"
import script from "./IUBHComplete.vue?vue&type=script&lang=js"
export * from "./IUBHComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports